<main fxLayout="column" fxLayoutAlign="center center">
    <nb-card>
        <nb-card-body fxLayout="column" fxLayoutAlign="center center">
            <img class="logo" src="../../../../assets/images/logo.png" alt="">
            <h2>Log in to admin</h2>

            <div class="form-group full-width">
                <label class="label" for="email">Username</label>
                <input nbInput [(ngModel)]="email" type="email" id="email" name="email" (keyup.enter)="login()"
                    placeholder="Enter your email">
            </div>

            <div class="form-group full-width">
                <label class="label" for="password">Password</label>
                <input nbInput [(ngModel)]="password" type="password" id="password" name="password"
                    (keyup.enter)="login()" placeholder="Enter your password">
            </div>

            <!--            <mat-checkbox [(ngModel)]="rememberMe">Remember me</mat-checkbox>-->

            <button mat-flat-button color="primary" (click)="login()" class="email-btn" [buttonSpinner]="isLoading">
                Login
            </button>


            <app-alert-error [error]="error"></app-alert-error>

            <!-- ----------------- UNCOMMENT FOR SOCIAL LOGIN ----------------- -->

            <!-- <p class="lined"><span>OR CONTINUE WITH</span></p>

            <div class="social-buttons" fxFlex="row" fxLayoutGap="10px">
                <button mat-flat-button color="warn" outline (click)="login('google')" fxFlex="auto">
                    <nb-icon icon="google"></nb-icon>
                    Google
                </button>

                <button mat-flat-button color="primary" outline (click)="login('facebook')" fxFlex="auto">
                    <nb-icon icon="facebook"></nb-icon>
                    Facebook
                </button>
            </div> -->
        </nb-card-body>
    </nb-card>
</main>
